import { render, staticRenderFns } from "./PDPAccordionItem.vue?vue&type=template&id=3b6385f2&scoped=true"
import script from "./PDPAccordionItem.vue?vue&type=script&lang=js"
export * from "./PDPAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./PDPAccordionItem.vue?vue&type=style&index=0&id=3b6385f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6385f2",
  null
  
)

export default component.exports